import { Input, Injectable, AfterViewInit, OnDestroy } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { AdSearchService } from '../services/adsearch.service';
import { DateToString } from 'src/app/core/pipe/pipe-date';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ViewService } from 'src/app/modules/realtor/components/view/view.service';
import { LINKS_CONFIG } from 'src/app/configs';
import { DialogActionComponent } from '../components/dialog-action/dialog-action.component';

declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

declare var $: any;
declare const window: any;

@Injectable({
  providedIn: 'root'
})

export abstract class AdUtils implements AfterViewInit, OnDestroy {

  @Input() data: any = {};
  @Input() viewInstance : any = {};
  @Input() scroll = null;

  tableType = 1;

  blockTabActive = null;

  private adType: string = 'building';

  private summary: any = {};

  collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base'
  });

  galleryOpened:any = false;

  settings:any = {};

  tableGroupOptions = {
    'typology' : 'unitByTypes',
    'floor' : 'unitByFloor',
    'number' : 'unitByNumber',
    'notgroup' : 'unitNotGroup'
  };
  
  navActive = false;
  typeLoad;
  idLoad;
  error = false;
  loading = true;
  
  info: any = {};

  table:any = [];
  tableBlockSelected:any = [];
  maxUnit = 0;

  dateDayOptions = {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  };

  dateOptions = {
    month: 'short',
    year: '2-digit'
  };

  tabActive = 'info';

  _unitTypeSelected:any = {};

  conditionDateOptions = {
    day: '2-digit',
    month: 'short',
    year: '2-digit'
  };

  widthQrCode = 130;

  conditionSelected:any = {};
  unitTypeSelected = null;

  showAvailable = false;
  showPromotion = false;
  tablePriceModeView = 'list';


  swiperTourConfig = {
    slidesPerView: 'auto',
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    zoom: false
  };

  swiperMainConfig = {
    slidesPerView: 'auto',
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    zoom: false
  };

  boxImagesSwiperConfig = {
    direction: 'horizontal',
    //navigation :true,
    slidesPerView: 1,
    spaceBetween: 30,
    zoom: false,
    pagination: {
        modifierClass: 'container pagination-',
        el: '.swiper-pagination',
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
            return '<span class="' + currentClass + '"></span>' +
            ' / ' +
            '<span class="' + totalClass + '"></span>';
        },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      2200: {
        slidesPerView: 5
      },
      1500: {
        slidesPerView: 4
      },
      1080 : {
        slidesPerView: 3
      },
      890 : {
        slidesPerView: 2
      },
      768 : {
        slidesPerView: 1
      },
      490 : {
        slidesPerView: 2
      }
    },
  };

  
  boxImagesRecreationAreaSwiperConfig = {...this.boxImagesSwiperConfig};
  boxImagesPlantsSwiperConfig = {...this.boxImagesSwiperConfig};
  boxImagesUnitsSwiperConfig = {...this.boxImagesSwiperConfig};

  boxImagesPromotionsSwiperConfig = {...this.boxImagesSwiperConfig, autoHeight: true,  observer: true, loop:false};

  linkGenerated = 0;
  shareLinkCopied = false;
  shareLink = '';
  shareLinkWhatsapp = '';
  startedShare = 0;

  actionSubscription : Subscription;

  protected backbuttonSuperSubscription: Subscription;
  restrictedAdSubscription : Subscription;

  private linkGenerator = new BehaviorSubject<any>([]);
  linkGenerator$ = this.linkGenerator.asObservable();


  printOpened = false;

  constructor(
    protected srs: AdSearchService,
    protected gs: GeneralService,
    protected vs : ViewService
  ) {

  }

  ngOnDestroy(){
    this.actionSubscription?.unsubscribe();
    this.restrictedAdSubscription?.unsubscribe();
    this.gs.setAction({});
  }

  async loadAd() {
    if (!this.data?.friendlyTitle)
      return false;
    
    let type = this.data.ad;
    let ndata = this.srs.getHitByFriendly(this.data.friendlyTitle, type, this.data.update);

    var th = this;
    if (!ndata?.typeId || this.data.update=='reload') {

        await this.srs.loadAd(this.data.friendlyTitle, { resultType: type })
        .then(item => {
          let data: any = item;

          if (!!data?.hits?.hits.length || !!data?.view?.hits?.hits.length) {
            th.data = th.srs.getHitByFriendly(th.data.friendlyTitle, type);
            th.setType();
            th.setDefault();
          } else {
            th.error = true;
            th.loading = false;
          }
        })
        .catch(() => {
          th.error = true;
          th.loading = false;
        })

      return;
    } else {
      if(this.data?.inner_hits)
        ndata.inner_hits = this.data?.inner_hits;

      this.data = ndata;

      this.setType();
      this.setDefault();

    }
  }

  abstract setDefault(): void;
  abstract eventCallback(ev): void;

  arrayKeyCustom(array, field, inArray = false) {
    let n = {};
    array.map(item => {
      if (inArray) {
        if (typeof n[item[field]] == 'undefined')
          n[item[field]] = [];

        n[item[field]].push(item);
      } else
        n[item[field]] = item;
    });
    return n;

  }

  setType() {
    this.adType = this.srs.getAdType(this.data.typeId);
  }

  setDefaultUtils(selectFirstUnit = false) {

    this.setType();

    
    this.settings = {
      table_group : 'typology',
      table_group_order : 'asc',
      table_order : 'desc',
      ...this.data?.settings || {}
    };

    let units = (this.data?.units || []).map(item => { 
      item.conditions = this.getConditionByUnit(item.id, item?.blockTypeId || 0, item?.blockId); 
      item.blockId = this.getBlockTypesById(item.blockTypeId)?.blockId || 0;
      
      if(item?.title){
        let numc = item.title.replace(/\D/g,'') || '0';
        item.number = parseInt(numc.substr(numc?.length-2));
        let start = parseInt(numc.substr(0,numc.length - 2));
        if(isNaN(start))
          start = 0;
              
        item.floor = start;
      } else {
        item.floor = 0;
        item.number = 0;
      }
      return item; 
    }).sort( (a, b) => {
      return this.collator.compare(a.title, b.title)
    });

    this.info = {
      ...Object.assign({}, this.data),
      featureStatus: this.getStatus('feature'),
      blockProgress: this.gs.getTags('blockProgress', this.adType).sort((a,b) => a?.attr?.sort - b?.attr?.sort),

      follow: this.getFollow('ad'),

      markerImage: this.getMarkerImage(),

      addressText: this.getAddress('ad-view'),
      addressDescription: this.getAddress('description'),

      recreation: this.getRecreation('features'),
      recreationLocale: this.getRecreation('locale'),

      paymentMethod: this.getPayment('method'),
      paymentDescription: this.getPayment('description'),

      unitStatus: this.arrayKeyCustom(this.getStatus('unit'), 'id'),
      unitType: this.arrayKeyCustom(this.getTag('unitType'), 'tag_id'),
      unitDetail: this.arrayKeyCustom(this.getTag('unitTypeDetail'), 'tag_id'),

      restrictedAllowed: this.gs.restrictedAllowed(this.data),

      unitByTypes: this.adjustBlocks(this.arrayKeyCustom(units, 'blockTypeId', true), this.settings.table_group_order, this.settings.table_order),

      unitByFloor: this.adjustBlocks(this.arrayKeyCustom(units, 'floor', true), this.settings.table_group_order, this.settings.table_order),

      unitByNumber: this.adjustBlocks(this.arrayKeyCustom(units, 'number', true), this.settings.table_group_order, this.settings.table_order),

      unitNotGroup: this.adjustBlocks(this.arrayKeyCustom(units, 'blockId', true), this.settings.table_group_order, this.settings.table_order),

      blockTypes: this.arrayKeyCustom((this.data?.unitTypes || this.data?.blockTypes)?.map(item => { item.roomText = this.getRoomText(item); return item }), 'blockId', true),
      amenities: this.getAmenities('amenities'),
      unitAmenities: this.getAmenities('unit-amenities'),
      categoryName : this.gs.getFeatureCategory(this.data.categoryId, this.gs.getModule()).name
    };

    const dateToString = new DateToString();
    
    let today = new Date();
    today.setHours(0,0,0,0);

/*
    
    if (!this.info?.promotionRealtorValid || new Date(this.info?.promotionRealtorValid.replace('T',' ').replace('Z',' ')+' +0000') >= today)
      this.info.promotionRealtorValidDate = true;

    if (this.info?.promotionRealtorValid)
      this.info.promotionRealtorValid = dateToString.transform(this.info.promotionRealtorValid, this.dateDayOptions);


    if (!this.info?.promotionClientValid || new Date(this.info?.promotionClientValid.replace('T',' ').replace('Z',' ')+' +0000') >= today)
      this.info.promotionClientValidDate = true;

    if (this.info?.promotionClientValid)
      this.info.promotionClientValid = dateToString.transform(this.info.promotionClientValid, this.dateDayOptions);


      */


    if (!this.info?.promotionRealtorValid || new Date(this.gs.getDate(this.info?.promotionRealtorValid)) >= today)
      this.info.promotionRealtorValidDate = true;

    if (this.info?.promotionRealtorValid){
      this.info.promotionRealtorValid = dateToString.transform(this.info.promotionRealtorValid, this.dateDayOptions);
      this.info.promotionRealtorImages = this.getFiles('public.ad.promotion_realtor', 'gallerize') || [];  
    }

    if (!this.info?.promotionClientValid || new Date(this.gs.getDate(this.info?.promotionClientValid)) >= today)
      this.info.promotionClientValidDate = true;

    if (this.info?.promotionClientValid){
      this.info.promotionClientValid = dateToString.transform(this.info.promotionClientValid, this.dateDayOptions);
      this.info.promotionClientImages = this.getFiles('public.ad.promotion_client', 'gallerize') || [];  
    }




    this.info.conditions = this.info?.conditions?.map(item => {
      if (item?.validUntil)
        item.validUntilStr = dateToString.transform(item.validUntil, this.conditionDateOptions);

      return item;
    }).filter(item => !item?.validUntil || new Date(this.gs.getDate(item.validUntil)) >= today);


    this.info.documents = this.getFiles('public.ad.documents', 'list')
      .map(item => {
        item.tags = this.getFileTags(item);
        item.href = this.gs.getFileName(item, 'first');
        return item;
      });
    this.info.images = this.getFiles('public.ad.images', 'gallerize');
    this.info.videos = this.getFiles('public.ad.videos', 'gallerize','large',false,'fileVideo');
    
    this.info.videosGeneral = this.getFilesArea(this.info.videos, 'general');
    this.info.videosExtras = this.getFilesArea(this.info.videos, 'highlight');

    this.info.imagesAndVideos = [].concat(this.info.images).concat(this.info.videosExtras);
    this.info.progress = this.getFiles('public.ad.progress', 'gallerize').sort((a,b) => (parseInt(a.sort) > parseInt(b.sort) ? -1 : 1));

    this.info.imagesGeneral = this.getFilesArea(this.info.imagesAndVideos, 'general');
    this.info.imagesGeneralAll = this.getFilesArea(this.info.imagesAndVideos, 'generalAll');
    this.info.imagesLogo = this.getFilesArea(this.info.images, 'logo');
    this.info.imagesHighlight = this.getFilesArea(this.info.imagesAndVideos, 'highlight');
    this.info.imagesUnits = this.getFilesArea(this.info.imagesAndVideos, 'units');
    this.info.imagesPlants = this.getFilesArea(this.info.imagesAndVideos, 'floorplan');
    this.info.imagesRecreationArea = this.getFilesArea(this.info.imagesAndVideos, 'recreationarea');
    this.info.imagesShowroom = this.getFilesArea(this.info.imagesAndVideos, 'showroom');
    this.info.imagesDelivery = this.getFilesArea(this.info.imagesAndVideos, 'delivery');
    this.info.imagesSocialArea = this.getFilesArea(this.info.images, 'socialArea');

    this.info.realtorLearning = this.getFilesArea(this.info.videos, 'realtorLearning');

    if(this.info?.owner?.logo && !this.info?.owner?.logoImg){
      this.info.owner.logo = this.gs.adjustAvatarFiles(this.info.owner, 'logo');
      this.info.owner.logoImg = this.gs.getAvatarFile(this.info.owner.logo);
    }

    if(this.data?.cover){
      this.info.avatarFiles = {thumb : this.gs.getFileName(this.data?.cover, 'thumb')};
    }

    this.info.statusText = this.info.typeId == 1? '' : (this.gs.getStatus('unit', this.adType, this.data.units[0]?.status,'name') || 'Indisponível');

    this.info.blocks = this.info?.blocks?.map(item => {

      item.maxgarage = 0;
      item.maxroom = 0;
      item.maxprivatearea = 0;
      item.maxdescription = 0;
      
      this.info?.blockTypes[item.id]?.map(types => {
        
        if(types?.room > item.maxroom)
          item.maxroom = types.room;

        if(types?.garage > item.maxgarage)
          item.maxgarage = types.garage;

        if(types?.privateArea > item.maxprivatearea)
          item.maxprivatearea = types.privateArea;

        if(types?.description?.length > item.maxdescription)
          item.maxdescription = types.description.length;
      });

      if(!item?.startDate && !item?.endDate)
        return item;

      if(typeof item.dateTransformed == 'undefined'){
        
        if(item?.startDate)
          item.startDate = dateToString.transform(item.startDate, this.dateOptions);

        if(item?.endDate)
          item.endDate = dateToString.transform(item.endDate, this.dateOptions);
      }
      item.dateTransformed = true;

      
      return item;
    });

    if(this.info?.pricedShareHash)
      this.info.linkQrCode = LINKS_CONFIG.share_link+this.info.pricedShareHash;

    this.setSummary();

    if(selectFirstUnit)
      this.info.unitTypeSelected = this.data.units[0];

    this.info.processed = true;
    
    this.loading = false;

  }

  adjustBlocks(list, group_sort = 'asc', sort = 'asc'){
    let firstBlock = null;
    let nl = [];
    Object.entries(list).forEach(([k,v]:any) => {

      v.map(item => {

        if(typeof nl[item.blockId] == 'undefined')
          nl[item.blockId] = [];

        if(typeof nl[item.blockId][k] == 'undefined')
          nl[item.blockId][k] = [];

        nl[item.blockId][k].push(item);
      })
    });

    for (var k in list) {
      firstBlock = k;
      break;
    }

    if(sort == 'desc')
      nl = nl.map(item => item.map(child => child.sort((a, b) => this.collator.compare(b.title, a.title))));

    if(group_sort == 'desc')
      nl = nl.map(item => item.reverse());

    this.blockTabActive = firstBlock;

    return nl;
  }

  // **************ACTIONS

  profile(e:any = {}) {
    if (e instanceof MouseEvent) 
      e?.stopPropagation();

    this.eventCallback({...e,action:'open-profile'});

    if (this.data?.owner?.personFriendlyName)
      this.srs.action(e, 'owner', this.data?.owner?.personFriendlyName);
    else
      this.gs.error(null, 'Não foi possível acessar, usuário excluído ou desativado.')

  }

  view(e) {
    this.eventCallback(e);

    switch (this.data?.ad) {
      case 'person':
        if (this.data?.personFriendlyName || this.data?.owner?.personFriendlyName)
          this.srs.action(e, 'owner', this.data?.personFriendlyName || this.data?.owner?.personFriendlyName);
        else
          this.gs.error(null, 'Não foi possível acessar, usuário excluído ou desativado.')
        break;
      default:
        if (this.data?.friendlyTitle)
          this.srs.action(e, 'view', this.data?.friendlyTitle, {update: this.data?.update});
        else
          this.gs.error(null, 'Não foi possível acessar, anúncio excluído ou desativado.')
        break;
    }

  }


  // **************DATA

  getAdTitle() {
    return this.data?.title;
  }
  getFollow(type) {
    switch (type) {
      case 'ad':
        return { type: type, id: this.data.adId, title: this.getAdTitle(), ownerPersonId: parseInt(this.getOwner('personId')), ownerName : this.getOwner('personName') };

      case 'person':
        return { type: type, id: parseInt(this.getOwner('personId')), title: this.getOwner('personName') };
    }
  }

  getOwner(key) {
    let data:any = this.data?.owner || this.data;

    if (key == undefined)
      return data;

    let gallery = (data?.galleries && typeof data?.galleries['public.person'] !== 'undefined' ? data.galleries['public.person'] : false) || data?.files;
    if (key == 'image') {
      let file = '';

      if (!!gallery?.length) {
        file = gallery.filter(item => item?.tags && item?.tags?.indexOf("52") > -1)[0] || gallery[0];
        return this.gs.getFileName(file, 'thumb');
      }

      if (data?.avatar) {
        return this.gs.getAvatarFile(data.avatar);
      }
    }

    switch (key) {
      case 'contacts':
        let contacts = [];
        let cellphone = this.getOwner('cellphone');
        let phone = this.getOwner('phone');

        if (cellphone)
          contacts.push(['mobile', cellphone]);

        if (phone)
          contacts.push(['work', phone]);

        return contacts;
      case 'publicIdText':
        return data?.public_idtext || data?.publicIdText || data?.personId;
      case 'personId':
        return data?.person_id || data?.personId;
      case 'site-address':
        return typeof data['site'] == 'undefined' || !data['site'] ? '' : data['site'].replace(/(^\w+:|^)\/\//, '');
      default:
        return typeof data !=='undefined' && data[key] != undefined ? data[key] : '';

    }
  }

  getCover(size) {
    if (!this?.data?.cover)
      return '';
    
    return this.gs.getFileName(this?.data?.cover, size);
  }

  getFileTags(file) {
    if (typeof file.tags == 'string')
      return file.tags;

    let txt = [];
    if(!!file?.tags?.length){
      let tags = this.getTag('fileDocument', file.tags);
      tags.map(item => txt.push(item.tag));
    }
    return txt.join(', ');
  }

  getFiles(gallery, local, size: any = 'large', condition: any = false, tagList = 'fileImage') {
    if (!this.data?.galleries || typeof this.data?.galleries[gallery] == 'undefined')
      return [];

    let g = this.data.galleries[gallery].sort((a, b) => a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0);
    if (!g.length)
      return [];

    switch (local) {
      case 'card-cover':
        return this.gs.getFileName(g[0], size);
      case 'gallerize':
        let ng = [];

        g.map(file => {
          let tags = !!file?.tags?.length ? this.getTag(tagList, file.tags, false) : [];
          let description = file?.description || '';
          let descHtml = '';
          let videoData:any = {};
          if(!!tags?.length || description){
            descHtml = '<div class="imageDescription">';
            if(!!tags?.length)
              tags?.map(tag => {
                if(tag?.attr?.type != 'highlight' && tag.tag != description)
                  descHtml+='<span>'+tag.tag+'</span>';
              });
            if(description)
              descHtml+= '<span>'+description+'</span>';
            descHtml+= '</div>';
          }
          file?.variations?.map(item => {
            item.href = this.gs.getFileName(file, item.resizeType, false, false, item);

            if(item?.mime.indexOf('video') > -1 && (item?.url || item?.href)){
              videoData.url = item?.url || item?.href;

              if(videoData.url.indexOf('vimeo') > -1){
                videoData.url = videoData.url.replace('https://vimeo.com/','');
                videoData.url = 'https://player.vimeo.com/video/'+((videoData.url.match(new RegExp("/", "g")) || []).length > 0? videoData.url.substr(0,videoData.url.indexOf('/')) : videoData.url);
              }

            }
          });

          if (!condition || (typeof condition == 'function' && condition(file)))
            ng.push({ href: this.gs.getFileName(file, 'large', false), ...this.gs.getFileName(file, 'large', true, 'src'), fileId: file.fileId, sort:file.sort, thumb: this.gs.getFileName(file, 'medium'), small: this.gs.getFileName(file, 'thumb'), description: description, subHtml:descHtml, tags: tags, mime: file.mime, originalData: file, ...videoData })
        });
    
        return ng.sort((a,b) => parseInt(a?.sort) - parseInt(b?.sort));

      default:
        return g;
    }
  }
  getFilesArea(files, area, needTags:any = false) {
    let nFiles = Object.assign([], files);
    let rFiles: any;
    let tags: any = [];
    let notEmpty = true;
    switch (area) {
      case 'highlight':
        rFiles = nFiles.filter(item => !!item?.tags.filter(tag => tag?.attr?.type == 'highlight').length).map(item => {
          item.tags = item.tags.filter(tag => tag?.attr?.type != 'highlight');
          return item;
        });
        //notEmpty = false;
        break;
      case 'general':
        tags = ["32","292","304"];//,"34", "35", "36", "37","302","303","304","292"]; //without tags
        rFiles = nFiles.filter(item => !item?.tags.filter(tag => tags?.indexOf(tag?.tag_id) > -1 && (!needTags || needTags?.indexOf(tag?.tag_id) > -1)).length);
        notEmpty = false;
        break;
      case 'generalAll':
        tags = ["34", "35", "36", "37","302","303","304","292"]; //without tags
        rFiles = nFiles.filter(item => !item?.tags.filter(tag => tags?.indexOf(tag?.tag_id) > -1 && (!needTags || needTags?.indexOf(tag?.tag_id) > -1)).length);
        notEmpty = false;
        break;
      default:
        switch (area) {
          case 'logo': tags = ["32"];  notEmpty = false; break;
          case 'units': tags = ["35", "36"];  notEmpty = false; break;
          case 'floorplan': tags = ["37"]; notEmpty = false; break;
          case 'recreationarea': tags = ["34"]; notEmpty = false; break;
          case 'showroom': tags = ["302"]; notEmpty = false; break;
          case 'delivery': tags = ["303"]; notEmpty = false; break;
          case 'socialArea': tags = ["304"]; notEmpty = false; break;
          case 'realtorLearning': tags = ["292"]; notEmpty = false; break;
        }
        rFiles = nFiles.filter(item => !!item?.tags.filter(tag => tags?.indexOf(tag?.tag_id) > -1).length);
        break;
    }
    return rFiles.length > 0 ? rFiles : (notEmpty ? nFiles.filter(item => !item?.tags.filter(tag => tag?.attr?.type == 'highlight').length) : []);

  }

  getAddress(local = '', owner = false) {

    let address = (owner ? this.data?.owner?.address : this.data?.address) || this.data;
    if (!address?.stateId)
      return '';

    let state = this.gs.getStates([parseInt(address.stateId)]);

    switch (local) {
      case 'geolocation':
        return address?.location?.lat && address?.location?.lon ? address.location.lat + ',' + address.location.lon : false;
      case 'navigateOpen':
        return { address: this.getAddress('', owner), geolocation: this.getAddress('geolocation', owner) };
      case 'description':
        return address.description || '';
      case 'ad-view-person':
        return [address.city, (state[0]?.acronym ? '/ ' + state[0].acronym : '')].join(' ');
      case 'card':
        return [(address?.street || '') + (address?.number ? ', n ' + address.number : ''), address.district, address.city + (state[0]?.acronym ? ' / ' + state[0].acronym : '')].filter(Boolean).join(' - ');
      case 'card-street':
        return [address.street, (address.number ? ', n ' + address.number : '')].join('');
      case 'card-city':
        return [address.district, '-', address.city, (state[0]?.acronym ? '/ ' + state[0].acronym : '')].join(' ');
      default:
        if (!address?.street || address.street == '')
          return [address.district, ' - ', address.city, (state[0]?.acronym ? '/ ' + state[0].acronym : '')].join('');

        return [(address?.street || '') + (address.number ? ', n ' + address.number : '') + (address.complement ? ' ' + address.complement : ''), address.district, address.city + (state[0]?.acronym ? ' / ' + state[0].acronym : '')].filter(Boolean).join(' - ');

    }



  }

  getTag(area, id = false, column: any = 'tag') {
    return this.gs.getTags(area, false, id, column);
  }

  getAmenities(local) {
    switch (local) {
      case 'amenities':
        return this.getTagsWithDescription('amenities');
      case 'unit-amenities':
        return this.getTagsWithDescription('unitAmenities');
    }
  }

  getPayment(local) {
    switch (local) {
      case 'description':
        return this.data?.paymentMethodDescription || '';

      case 'method':
        return this.getTagsWithDescription('paymentMethod');
    }

  }

  getRecreation(local) {
    switch (local) {
      case 'locale':
        return this.gs.getTags('recreationAreaLocale', this.adType).filter(item => this.data?.recreationLocale && this.data?.recreationLocale.indexOf(parseInt(item.tag_id)) > -1) || [];
      case 'features':
        return this.getTagsWithDescription('recreationArea');
    }
  }

  getTagsWithDescription(local) {
    return this.gs.getTags(local, this.adType).filter(item => typeof this.data[local + 'Ids'] != 'undefined' && this.data[local + 'Ids'].indexOf(parseInt(item.tag_id)) > -1).map(item => { item.description = this.data[local][item.tag_id] || ''; return item; }).sort((a, b) => a?.tag.localeCompare(b?.tag)) || [];
  }

  getDate(field) {
    if (typeof this.data[field] !== 'undefined')
      return this.data[field];

    return '';
  }

  getCategory(id) {

  }

  getStatus(local, id = null, col = null) {

    let status: any;

    let adType = this.srs.getAdType(this.data?.typeId || this.info?.typeId || parseInt(this.gs.getFeatureCategory(this.data.ad_category_id)?.type_id));

    switch (local) {
      case 'ad':
        //TODO - setar o status do anuncio no banco e capturar.
        return 1;
      case 'feature':
        status = this.gs.getTags('featureStatus', adType).filter(item => this.data?.featureStatus && parseInt(this.data?.featureStatus) == parseInt(item.tag_id));
        return !status.length ? {alias:''} : status[0][col === null? 'tag' : col];

      case 'unit':
        status = this.gs.getStatus('unit', adType, id?.toString());
        return !status? {alias:''} : status;
    }
  }

  setSummary() {
    
    let inner_units = this.data?.inner_hits?.units?.hits?.hits;

    this.summary = {
      room: [],
      bathroom: [],
      garage: [],
      suite: [],
      privateArea: [],
      totalArea: [],
      units: 0,
      available: 0,
      amount: [],
      floors: [],
      blocks: 0,
      
      amountMin: '',
      amountMax: '',
      blockDelivery: [],
      color: null,
      brand: null,
      model: null, 
      km: null,
      year: null
    };
    this.summary.inner = Object.assign({}, this.summary);

    let blocks = this.data?.blocks;
    let units = this.data?.units || [];
    
    if (!!blocks?.length) {
      this.summary.blocks = blocks.length;

      blocks.map(item => {
        if (this.summary.floors.indexOf(item?.floors) == -1)
          this.summary.floors.push(item.floors);
      });

      this.summary.blockDelivery = this.getBlocksDelivery();
    }

    if(inner_units){

      this.summary.inner.available = inner_units.length;


      inner_units.map(unit => { 
        if (unit?._source?.amount || unit?.amount)
            this.summary.inner.amount.push(parseFloat(unit?._source?.amount || unit?.amount)); 
          
        if (unit?._source?.bathroom || unit?.bathroom)
          this.summary.inner.bathroom.push(parseInt(unit?._source?.bathroom || unit?.bathroom)); 
          
        if (unit?._source?.room || unit?.room)
          this.summary.inner.room.push(parseInt(unit?._source?.room || unit?.room));

        if (unit?._source?.suite || unit?.suite)
          this.summary.inner.suite.push(parseInt(unit?._source?.suite || unit?.suite));
      });


      ['km', 'year', 'brand', 'model', 'color'].map(item => {
        if (typeof inner_units[0]._source[item] !== 'undefined')
          this.summary.inner[item] = inner_units[0]._source[item];
      });
      
      ['bathroom', 'room', 'suite', 'amount'].map(item => {
        if (typeof inner_units[0]._source[item] !== 'undefined')
          this.summary.inner[item] = Array.from(new Set(this.summary.inner[item])).sort();
      });

      Object.entries(this.summary).forEach(([key, value]) => {
        if (['garage', 'privateArea','totalArea'].indexOf(key) > -1) {
          inner_units.map(unit => {
            if (typeof unit[key] !== 'undefined' || (unit?._source && typeof unit?._source[key] !== 'undefined')) {
              let vl = typeof unit[key] !== 'undefined' ? unit[key] : unit?._source[key];
              if (this.summary[key].indexOf(vl) == -1 && (vl) > 0)
                this.summary[key].push(vl)
            }
          });
          this.summary[key].sort((a, b) => a - b);
        }
      });
  
      this.summary.inner.amountMin = Math.min.apply(null, this.summary.inner.amount);
      this.summary.inner.amountMax = Math.max.apply(null, this.summary.inner.amount);
  
      Object.entries(this.summary.inner).forEach(([k, v]) => {
          this.info['_inner_'+k] = this.getSummary(k,true);
      });

      
    }

    if (!!units?.length) {
      this.summary.units = units.length; 

      var available = units.filter(unit => (unit?._source?.status || unit?.status) == 11); //&& (!inner_units?.length || !!inner_units?.filter(item=>item._source.id == unit.id)?.length)



      this.summary.available = available.length;

      available.map(unit => { 
          if (unit?._source?.amount || unit?.amount)
              this.summary.amount.push(parseFloat(unit?._source?.amount || unit?.amount)); 
            
          if (unit?._source?.bathroom || unit?.bathroom)
            this.summary.bathroom.push(parseInt(unit?._source?.bathroom || unit?.bathroom)); 
            
          if (unit?._source?.room || unit?.room)
            this.summary.room.push(parseInt(unit?._source?.room || unit?.room));

          if (unit?._source?.suite || unit?.suite)
            this.summary.suite.push(parseInt(unit?._source?.suite || unit?.suite));
      });

      this.info._suitemax = !!this.summary.suite?.length? Math.max.apply(null,this.summary.suite) : 0;
      this.info._roommax = !!this.summary.room?.length? Math.max.apply(null,this.summary.room) : 0;

      ['km', 'year', 'brand', 'model', 'color'].map(item => {
        if (typeof units[0][item] !== 'undefined')
          this.summary[item] = units[0][item];
      });
      
      ['bathroom', 'room', 'suite', 'amount'].map(item => {
        if (typeof units[0][item] !== 'undefined')
          this.summary[item] = Array.from(new Set(this.summary[item])).sort();
      });

      Object.entries(this.summary).forEach(([key, value]) => {
        if (['garage', 'privateArea','totalArea'].indexOf(key) > -1) {
          units.map(unit => {
            if (typeof unit[key] !== 'undefined' || (unit?._source && typeof unit?._source[key] !== 'undefined')) {
              let vl = typeof unit[key] !== 'undefined' ? unit[key] : unit?._source[key];
              if (this.summary[key].indexOf(vl) == -1 && (vl) > 0)
                this.summary[key].push(vl)
            }
          });
          this.summary[key].sort((a, b) => a - b);
        }
      });

      this.summary.amountMin = Math.min.apply(null, this.summary.amount);
      this.summary.amountMax = Math.max.apply(null, this.summary.amount);

      Object.entries(this.summary).forEach(([k, v]) => {
        this.info['_'+k] = this.getSummary(k);
      });
    }

    this.info._restrictedAllowed = this.gs.restrictedAllowed(this.data);

    if(this.info?.adId && this.info.restricted && !this.info._restrictedAllowed){

      this.gs.requestRestrictedReload();
    }

  }

  getSummary(key, inner = false) {
    let sum = inner? this.summary.inner[key] : this.summary[key];

    
    if (sum == '' || sum === null || typeof sum == 'undefined')
      return '';

    if (key == 'blockDelivery')
      return sum;

    let minV = false;
    let maxV = false;

    if (typeof sum == 'object') {
      minV = Math.min.apply(null, sum);
      maxV = Math.max.apply(null, sum);
    }

    let comma = ", ";
    switch (key) {
      case 'amountMin':
      case 'amountMax':
      case 'blocks':
      case 'units':
      case 'available':
      case 'year':
      case 'model':
      case 'brand':
      case 'km':
      case 'color':
        return (sum == Number.POSITIVE_INFINITY || sum == Number.NEGATIVE_INFINITY)? 0 : sum;

      case 'room':
      case 'bathroom':
      case 'suite':
      case 'garage':
        if (typeof sum == 'number')
          return sum;

        if (sum?.length <= 2)
          return sum.join(' e ');

        if (sum?.length > 2)
          return minV + ' a ' + maxV;

      case 'totalArea':
      case 'privateArea':
        var sufix = "m²";

        if (sum?.length <= 2)
          return sum.join(' e ') + sufix;

        if (sum?.length > 2)
          return minV + ' a ' + maxV + sufix;

      default:
        if (!!sum?.length)
          return sum.join(comma);
    }

    return '';
  }

  getBlocks(id: any = false, onlyAvailable: any = false) {

    if (!this.data?.blocks)
      return [];

    let blocks = id != false ? this.data.blocks[id] : this.data.blocks;

    return onlyAvailable ? blocks.filter(item => !!this.getUnits(item.id, false, onlyAvailable).length) : blocks;
  }

  getBlockTypes(blockId) {
    return this.data?.blockTypes?.filter(item => item.blockId == blockId);
  }
  getBlockTypesById(id) {
    return (this.data?.unitTypes || this.data?.blockTypes).filter(item => item.id == id)[0];
  }

  getBlockTypesTooltip(id) {
    let blockType = this.getBlockTypesById(id);

    var tooltip = ''; 

    var typeTitle = this.getTag('unitType', blockType?.typeId);

    if (typeTitle)
      tooltip += typeTitle;

    if (tooltip && blockType?.description)
      tooltip += ' - ';

    if (blockType?.description)
      tooltip += blockType.description;

    return tooltip;
  }

  getBlocksDelivery(id: any = false) {
    let blocks = this.getBlocks(id);
    let dates = [];

    blocks.map(block => {
      if(block.startDate || block.endDate){
        let nd = { startDate: block.startDate, endDate: block.endDate, names: [] };
        let pos: any = -1;
        Object.entries(dates).forEach(([key, value]) => {
          if (value?.startDate == block.startDate && value?.endDate == block.endDate)
            pos = key;
        });
        if (pos == -1) {
          dates.push(nd);
          pos = dates.length - 1;
        }

        dates[pos].names.push({ name: block.name, incorporation: block?.incorporation });
      }

    });

    return dates;

  }

 getUnits(blockId, blockTypeId, onlyAvailable) {
    let th =this;

    return this.data?.units.filter(item =>
      (item.blockId == blockId || this.getBlockTypesById(item.blockTypeId)?.blockId == blockId ) &&
      //item.blockId == blockId &&
      (!blockTypeId || item.blockTypeId == blockTypeId) &&
      (!onlyAvailable || (onlyAvailable && item.status == 11))
    ).sort(function (a, b) {
      return th.collator.compare(a.title, b.title)
    });
  }

  getRoomText(data) {
    let txt = '';
    if (data.suite == 0 || data.room != data.suite)
      txt += data.room;

    if (data.suite > 0) {
      if (data.room != data.suite)
        txt += ' dorm. (';

      txt += data.suite + ' suíte' + (data.suite > 1 ? 's' : '');

      if (data.room != data.suite)
          txt += ')';
    }

    if(txt == '0')
      return '';

    return txt;
  }

  getMarkerImage() {
    return this.gs.buildImagemUrl('logo-footer.png');
  }

  getConditionByUnit(unitId, unitTypeId, blockId){
    let hasByUnit = false;
    let hasGeneral = false;
    let hasByUnitType = false;
    let hasByBlock = false;
    this.data?.conditions?.map(item => {
      if(!item?.validUntil || new Date(item.validUntil) >= new Date()){
        if((!item?.applyUnits || !item?.applyUnits?.length) && (!item?.applyUnitTypes || !item?.applyUnitTypes?.length) && (!item?.applyBlocks || !item?.applyBlocks?.length))
          hasGeneral = true;

        if(item?.applyUnits?.indexOf(unitId) > -1)
          hasByUnit = true;

        if(item?.applyUnitTypes?.indexOf(unitTypeId) > -1)
          hasByUnitType = true;
          
        if(item?.applyBlocks?.indexOf(blockId) > -1)
          hasByBlock = true;
      }
    });
    return {hasByUnit : hasByUnit, hasByUnitType: hasByUnitType, hasByBlock: hasByBlock, hasGeneral: hasGeneral};
  }

  setConditionSelected(condition) {
    this.conditionSelected = condition;
    
  }


  setGallery(dataItem, galleryList = 'imagesAndVideos', filter = true) {

    var images = [];
    let index: any = 0;
    if(typeof this.info[galleryList] !=='undefined')
    Object.entries(this.info[galleryList]).forEach(([key, value]: any) => {
        if (!filter || (!value['tags']?.filter(tag => tag?.attr?.type == 'highlight' || [32].indexOf(parseInt(tag.tag_id)) > -1)?.length || typeof value.tags == 'undefined')) {

            if ((value?.fileId && value?.fileId == dataItem?.fileId) || (value?.id && value?.id == dataItem?.id))
                index = parseInt(key);
            
           
            if (dataItem?.type == 'iframe') {
                images.push({
                    content: '<iframe src="' + (value?.link || value?.url) + '" width="100%" style="height:calc(100vh - 88px); margin-top:44px;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>',
                    //title: value?.subHtml || value?.title || ''
                });
            } else if (value?.url)
                images.push({
                    content: '<iframe src="' + value.url + '/?autoplay=1" width="100%" height="100%" frameborder="0" class="video" allow="autoplay; fullscreen" allowfullscreen></iframe>',
                    //title: value?.subHtml || value?.title || ''
                });
            else
                images.push(
                    {
                        src: value['src'],
                        w: value['src_width'],
                        h: value['src_height'],
                        title: value?.subHtml || value?.title || ''
                    }
                );
        }
    });

    var pswpElement = document.querySelectorAll('.pswp')[0];
    // Initializes and opens PhotoSwipe

    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, {
        index: index, // start at first slide
        preloaderEl: false,
        placeholder:true,
        history : false
    });

    gallery.listen('afterChange', ()=>{
        let items = gallery.items;
        if (!!items?.length ) {
            let cur = gallery.getCurrentIndex();

            Object.entries(items).forEach(([item,v]) => {
                if(item != cur && items[item]?.content && items[item] && typeof items[item].container !== 'undefined' && items[item]?.container)
                    items[item].container.innerHTML = '';
            });
            
            if (items[cur]?.content && typeof items[cur].container !== 'undefined')
                items[cur].container.innerHTML = items[cur]?.content;

            if (items[cur]?.content?.indexOf('video') > -1)
                pswpElement.classList.add('tiny');
            else
                pswpElement.classList.remove('tiny');
        } else {
            pswpElement.classList.remove('tiny');
        }
    });

    gallery.listen('close', (e) => {

        this.galleryOpened = false;
        if(this.viewInstance?.lightGalleryOpened)
            this.viewInstance.lightGalleryOpened = false;

        pswpElement.querySelectorAll('iframe').forEach(i => {
            i.remove();
        });
    });

    gallery.init();

    this.galleryOpened = gallery;
}

/*
  setGallery(dataItem, galleryList = 'imagesAndVideos') {

    var images = [];
    let index:any = 0;

    Object.entries(this.info[galleryList]).forEach(([key, value]:any) => {
      if(!value['tags'].filter(tag => tag?.attr?.type == 'highlight' || [32].indexOf(parseInt(tag.tag_id)) > -1).length){

        if(value['fileId'] == dataItem?.fileId)
          index = parseInt(key);

        if(value?.url)
          images.push({
            html: '<iframe src="'+value.url+'" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
          })
        else
          images.push(
            {
              src: value['src'], 
              w: value['src_width'], 
              h: value['src_height'],
              title : value['subHtml']
            }
          );
      }
    });


    var pswpElement = document.querySelectorAll('.pswp')[0];
    // Initializes and opens PhotoSwipe

    var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, images, {
      index: index, // start at first slide
      history:false,
      timeToIdle:0
    });

    gallery.listen('close',() => {
      this.viewInstance.lightGalleryOpened = false;
    });

    gallery.init();
  }
  */

  action(event, action, id) {
    if (event instanceof MouseEvent)
      event?.stopPropagation();

    switch (action) {
      case 'goTo':
        return this.srs.action(event, action, id, { offsetTop: this.gs.isMobile() ? -60 : -120 });
    }
    this.srs.action(event, action, id);
  }

  setTablePriceModeView(mode){
    this.tablePriceModeView = mode;
  }

  navClick(event: any) {
    event.target.classList.add('active');
  }

  generateTable(blockSel = false, getArray = false, onlyAvailable = false, byFloors = true){ 
    this.table = [];
    this.getBlocks().map(block => {
        if(!blockSel || blockSel == block.id){
          if(byFloors)
          this.table.push({ id: block.id, name: block.name, floor: parseInt(block.unit_floor), floors : this.adjustUnits(this.getUnits(block.id, false, onlyAvailable), 1)});
          else
            this.table.push({ id: block.id, name: block.name, units : this.getUnits(block.id, false, onlyAvailable)});
        }
    });

    if(getArray)
      return blockSel == false? this.table : this.table.filter(item => item.id == blockSel);

    return this.tableBlockSelected = this.table[0];
  }

  adjustUnits(units, floorStart){
      let nu = [];

      units.map(unit => {
          let numc = unit.unitNum = unit.title.replace(/\D/g,'') || '0';
          
          let start = parseInt(numc.substr(0,numc.length - 2));
          if(isNaN(start))
            start = 0;
          let num = parseInt(numc.substr(numc.length - 2));
          
          let floor = (floorStart + start - 1);
          if(typeof nu[floor] == 'undefined')
            nu[floor] = {floor : floor, units : []};

          unit.type = this.getBlockTypesById(unit.blockTypeId);

          unit.amountNum = parseInt(unit.amount);
          if(isNaN(unit.amountNum))
            unit.amountNum = 0;

          unit.amountOldNum = parseInt(unit.amountOld);
          if(isNaN(unit.amountOldNum))
            unit.amountOldNum = 0;

          if(!nu[floor].units.filter(u => u.unitNum == unit.unitNum && u.id!='empty')?.length){
            nu[floor].units = nu[floor].units.filter(u => u.unitNum != unit.unitNum);
            nu[floor].units.push(unit);
          }
          nu[floor].units.sort((a,b) => a?.unitNum - b?.unitNum);

          let nEmpS = parseInt(floor + Array(nu[floor]?.units[0].unitNum?.length-floor?.toString().length).join("0") + '1');
          let nEmpE = parseInt(nu[floor]?.units[nu[floor]?.units?.length-1].unitNum);

          if(nu[floor]?.units.length < nEmpE - nEmpS +1){
              for(let p = nEmpS, i = 0; p <= nEmpE; p++, i++){
                if(!nu[floor]?.units.filter(u => parseInt(u.unitNum) == p)?.length)
                  nu[floor].units.splice(i, 0, {id:'empty', unitNum: p.toString()});
              }
          }

          if(nu[floor].units.length > this.maxUnit)
              this.maxUnit = nu[floor].units.length;
      });

      
      return nu.reverse().filter(Boolean);
  }

  hasClass(el, className) {
    return (" " + el.className + " ").replace(/[\n\t]/g, " ").indexOf(" " + className + " ") > -1;
  }

  openMap(data: any) {
    this.gs.openMap(data);
  }
  
  ngAfterViewInit(){

    if(this.actionSubscription)
      this.actionSubscription?.unsubscribe();

    if(this.restrictedAdSubscription)
      this.restrictedAdSubscription?.unsubscribe();

    if(!this.data?.adId)
      return;

    this.actionSubscription = this.gs.actions$.subscribe(result => {
      if(result?.adId == this.info?.adId && this.viewInstance?.typeComponent)
        switch(result?.action){
          case 'lightGallery':
            console.log(result);
            this.setGallery(result.item, result.galleryList || 'imagesAndVideos');
          break;
        }
    });

    this.restrictedAdSubscription = this.gs.restrictedAd$.subscribe(result => {
      this.data._restrictedAllowed = this.info.restrictedAllowed = this.info._restrictedAllowed = this.gs.restrictedAllowed(this.data);      
    });

  }

  requestRestricted(){ 
    this.gs.requestRestricted(this.data);
  }

  setShare(ev){
    this.startedShare++;
  }

  async createShareLink(data:any = false, attr:any = false){
    if(!(this.info?.adId || this.info?.ad_id))
      return;
      
    this.shareLink = '';
    this.shareLinkWhatsapp = '';
    this.shareLinkCopied = false;
    this.linkGenerated = 1;

    console.log(data, attr);
    if(!data){
      data = { 
        attr : attr || {
          ad_id : this.info?.adId || this.info?.ad_id,
        },
        message : (this.info?.unit_id? 
                    '*'+this.info?.title?.trim()+'*\n\n'+
                    '*Unidade - '+this.info.unit_title+'*\n'+
                    'Valor: '+this.info.unit_amountTotal+'\n\n'+
                    'Mais informações acesse o link: %link%'
                  :
                    '*'+this.info?.title?.trim()+'*\n\nMais informações acesse o link: %link% \n\n Fico à disposição para mais informações')
      };
    }

    await this.gs.shareLink(data.attr).then(result => {
        if(result){
          let link = this.shareLink= result;
          let whatsappMessage = data?.message? data?.message.replace('%link%',link) : link;
          this.shareLinkWhatsapp='https://wa.me/?text='+window.encodeURIComponent(whatsappMessage);
          this.linkGenerated = 2;
        } else {
          this.linkGenerated = 0;
        }
        this.linkGenerator.next(this.linkGenerated);
    });
  }

  setTab(id){
    this.tabActive = id;
  }

  print(e,el, type){
    this.closeDropdown(e);
    this.tableType = type;
    this.printOpened=true;
    var th = this;

    e.stopPropagation();
    setTimeout(() => 
      $(el).printThis({
        importStyle: true,
        printContainer:false,
        debug:true,
        printDelay:400,
        afterPrint: () => { th.printOpened = false; }
    }), 150);
  }

  navActiveToggle(e){
    e.stopPropagation();
    this.navActive = !this.navActive;
  }

  setRequestAction(event, action, data){
    
    if(!this.adType)
      return;

    switch(action){
      case 'authorization':
        if(!data?.allowAuthorizationRequests){
          this.openDisableMessage(this.data, 'Este anúncio não permite solicitar autorização de venda');
          return;
        }

        data.type_id = '3';
      break; 
      case 'material':
        if(!data?.allowMaterialRequests){
          this.openDisableMessage(this.data, 'Este anúncio não permite solicitar autorização de venda');
          return;
        }
          data.type_id = '2';
      break; 
      case 'training':
        this.training(this.data);
        return;
      break;
    }

    this.vs.setCallback({action:action,data:data});
  }

  async training(data){
    let txt = 'Olá, gostaria de agendar treinamento referente ao anúncio *'+data.title.trim()+'* que encontrei na Central Corretor.\n\nLink referência: https://centralcorretor.com.br/perfil/'+data.owner.personFriendlyName+'/'+data.friendlyTitle;
   
    var  element = document.createElement('a') as HTMLElement;
    element.setAttribute('href', (window?.mobileAndTabletCheck()? 'whatsapp://send': 'https://web.whatsapp.com/send')+'?phone='+data.owner.cellphone+'&text='+encodeURI(txt));
    element.setAttribute('style', 'display:none;');
    element.setAttribute('target', '_blank');
    element.click();
  }

  openDisableMessage(data, message, title = 'Função bloqueada'){
    const dialogRef = this.gs.dialog.open(DialogActionComponent, 
      {
       data: {
          title:title,
          content:'<b class="mb-3 d-block">'+message+'</b>',
          cancelTitle:'OK',
          okTitle:'Conversar com anunciante'
      }});

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        let txt = 'Olá, encontrei o anúncio *'+data.title.trim()+'* na Central Corretor.\n\nLink referência: https://centralcorretor.com.br/perfil/'+data.owner.personFriendlyName+'/'+data.friendlyTitle;
              
        var  element = document.createElement('a') as HTMLElement;
        element.setAttribute('href', (window?.mobileAndTabletCheck()? 'whatsapp://send': 'https://web.whatsapp.com/send')+'?phone='+data.owner.cellphone+'&text='+encodeURI(txt));
        element.setAttribute('style', 'display:none;');
        element.setAttribute('target', '_blank');
        element.click();
      }
        
    });
  }
  
  closeDropdown(ev){
    $('.dropdown-toggle').dropdown('dispose');
    $('.btn-group.show, .dropdown-menu.show').removeClass('show');
  }

}